import {HubConnectionBuilder} from "@aspnet/signalr";

class Socket {
    constructor(props) {
        this.url = props?.url || window?.ENV?.SIGNALR_WS_DOMAIN || 'null';
        this.token = props?.token || null;

        this.connection = new HubConnectionBuilder()
            .withUrl(this.url, {accessTokenFactory: _ => this.token})
            .build();
    }

    connect() {
        return new Promise((resolve, reject) => {
            this.connection.start().then(_ => {
                resolve();
            }).catch(message => {
                reject(message);
            });
        });
    }

    disconnect() {
        this.connection.stop();
    }

    onReceiveNotification(callback = _ => null) {
        this.connection.on("ReceiveNotification", data => {
            callback(JSON.parse(data));
        });
    }
}

export default Socket